import { RESET_ALL as RESET_ON_LOGOUT } from '../../../redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import type { Action } from 'types';

const LOADING = 'conversationLinks/LOADING';
const LOADED = 'conversationLinks/LOADED';
const RESET = 'conversationLinks/RESET';

const { MESSENGER } = API.END_POINTS;

const initialState = {
  isLoading: false,
  list: []
};

export function setLoadingStatus(status: boolean): Action {
  return {
    type: LOADING,
    payload: {
      status
    }
  };
}

function linksLoaded(links) {
  return {
    type: LOADED,
    payload: {
      links
    }
  };
}

export function resetLinks() {
  return {
    type: RESET,
    payload: {}
  };
}

export function fetchLinks(conversationId) {
  const url = MESSENGER.getConversationlinks(conversationId);

  return async (dispatch) => {
    dispatch(setLoadingStatus(true));

    try {
      const response = await get(url, {}, { suppressGlobalNotification: true });
      const links = response.data;

      dispatch(linksLoaded(links));
    } catch (error) {
      dispatch(linksLoaded([]));
      dispatch(setLoadingStatus(false));
      throw error;
    }
  };
}

export default createReducer<any, any>('conversationLinks', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [LOADED]: (state, { links }) => ({
    ...state,
    list: links,
    isLoading: false
  })
});
